import React, { memo, useRef } from 'react';
import { v4 as uuid } from 'uuid';

import FormControl from '@mui/material/FormControl';
import InputBase from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme }) => ({
  width: '100%',
  background: 'var(--color-surface)',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  outline: 'none',
  height: '40px',
  transition: 'border-color 0.15s ease, background-color 0.15s ease',
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },
}));

const StyledInput = styled(InputBase)(({ theme }) => ({
  width: '100%',
  height: '40px',
  outline: 'none',
  paddingLeft: '8px',
  '& input': {
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  '& input::placeholder': {
    color: 'var(--color-text-muted)',
    opacity: 1,
  },
  '& .MuiInputAdornment-root': {
    color: 'var(--color-text-muted)',
  },
}));

const Search = (props) => {
  const {
    value = '',
    disabled = false,
    placeholder = 'Search',
    onChange = () => {},
  } = props;
  const inputIdRef = useRef(`search-${uuid()}`);

  return (
    <StyledFormControl>
      <StyledInput
        id={inputIdRef.current}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        startAdornment={<SearchIcon sx={{ mr: 1, color: 'var(--color-text-muted)' }} />}
        endAdornment={
          value && (
            <InputAdornment position="end" sx={{ mr: 1 }}>
              <IconButton
                size="small"
                aria-label="clear input"
                onClick={() => onChange({ target: { value: '' } })}
                sx={{ color: 'var(--color-text-muted)' }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </StyledFormControl>
  );
};

export default memo(Search);
